import React from 'react';
import './App.css';
import Pathfinder from './Pathfinding/Pathfinding'



function App() {
  return (
      < div className='App'>
          <Pathfinder></Pathfinder>
      </div>



  );
}

export default App;
